export default __webpack_public_path__ + "static/media/iossettings1.ff0a0215.png";